(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuveya-cart"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.nv-cart__quantity button').forEach(button=>button.addEventListener('click',()=>{const input=button.parentElement.querySelector('input');input.value=Math.max(0,Number(input.value||0)+Number(button.dataset.nvCartStep));document.querySelector('[data-nv-cart-update]')?.click()}));
document.querySelectorAll('.nv-cart__quantity input').forEach(input=>input.addEventListener('change',()=>document.querySelector('[data-nv-cart-update]')?.click()));
document.querySelectorAll('[data-nv-discount-apply]').forEach(button=>button.addEventListener('click',()=>{const code=button.parentElement.querySelector('[data-nv-discount-code]').value.trim();if(code)location.href=(window.Shopify?.routes?.root||'/')+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent('/cart')}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuveya-community"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-nv-review-carousel]').forEach(carousel=>{const slides=[...carousel.querySelectorAll('[data-nv-review]')];const prev=carousel.querySelector('[data-nv-review-prev]');const next=carousel.querySelector('[data-nv-review-next]');let current=0;function show(index){if(!slides.length)return;current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===current));prev.disabled=current===0;next.disabled=current===slides.length-1}prev.addEventListener('click',()=>show(current-1));next.addEventListener('click',()=>show(current+1));show(0)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuveya-header"] && !Shopify.designMode) return;
  try {
    
const nvCartBase=window.Shopify?.routes?.root||'/';
async function nvCartRefresh(open){
  const sectionId=document.querySelector('[data-nv-cart-drawer]')?.dataset.nvSectionId;
  if(!sectionId)throw new Error('Ostoskoria ei voitu päivittää');
  const url=new URL(nvCartBase,location.origin);
  url.searchParams.set('sections',sectionId);
  const preview=new URLSearchParams(location.search).get('preview_theme_id');
  if(preview)url.searchParams.set('preview_theme_id',preview);
  const response=await fetch(url,{credentials:'same-origin'});
  const sections=await response.json();
  if(!sections[sectionId])throw new Error('Ostoskoria ei voitu päivittää');
  const fresh=new DOMParser().parseFromString(sections[sectionId],'text/html');
  const next=fresh.querySelector('[data-nv-cart-drawer]');
  if(!next)throw new Error('Ostoskoria ei voitu päivittää');
  document.querySelector('[data-nv-cart-drawer]').replaceWith(next);
  const nextCount=fresh.querySelector('.nv-header__actions small');
  const currentCount=document.querySelector('.nv-header__actions small');
  if(nextCount&&currentCount)currentCount.textContent=nextCount.textContent;
  if(open){next.classList.add('is-open');document.body.classList.add('nv-cart-lock');next.querySelector('.nv-cart-drawer__head button')?.focus()}
  return next;
}
function nvCartClose(){document.querySelector('[data-nv-cart-drawer]')?.classList.remove('is-open');document.body.classList.remove('nv-cart-lock')}
async function nvCartChange(key,quantity){
  const response=await fetch(nvCartBase+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
  if(!response.ok){const data=await response.json();throw new Error(data.description||data.message||'Ostoskoria ei voitu päivittää')}
  await nvCartRefresh(true);
}
document.addEventListener('click',async event=>{
  const opener=event.target.closest('[data-nv-cart-open]');
  if(opener){event.preventDefault();try{await nvCartRefresh(true)}catch{location.href=opener.href}return}
  if(event.target.closest('[data-nv-cart-close]')){nvCartClose();return}
  const change=event.target.closest('[data-nv-cart-change],[data-nv-cart-remove]');
  if(change){const key=change.dataset.itemKey;const quantity=change.hasAttribute('data-nv-cart-remove')?0:Number(change.dataset.quantity);change.disabled=true;try{await nvCartChange(key,quantity)}catch(error){const message=document.querySelector('[data-nv-cart-error]');if(message)message.textContent=error.message;change.disabled=false}}
});
document.addEventListener('change',async event=>{
  const select=event.target.closest('[data-nv-cart-variant]');
  if(!select)return;
  const key=select.dataset.itemKey;
  const quantity=Number(select.closest('.nv-cart-drawer__item').querySelector('.nv-cart-drawer__stepper span').textContent);
  select.disabled=true;
  try{
    const add=await fetch(nvCartBase+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity}]})});
    if(!add.ok){const data=await add.json();throw new Error(data.description||data.message||'Tuotetta ei voitu lisätä')}
    await nvCartChange(key,0);
  }catch(error){const message=document.querySelector('[data-nv-cart-error]');if(message)message.textContent=error.message;select.disabled=false}
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')nvCartClose()});
document.addEventListener('submit',async event=>{
  const form=event.target;
  if(!form.matches('#nv-product-form'))return;
  event.preventDefault();
  const button=form.querySelector('button[type="submit"]');
  if(button)button.disabled=true;
  let message=form.querySelector('.nv-product__error');
  if(!message){message=document.createElement('p');message.className='nv-product__error';message.setAttribute('role','alert');form.append(message)}
  message.textContent='';
  try{
    const response=await fetch(nvCartBase+'cart/add.js',{method:'POST',body:new FormData(form)});
    const data=await response.json();
    if(!response.ok)throw new Error(data.description||data.message||'Tuotetta ei voitu lisätä ostoskoriin');
    try{await nvCartRefresh(true)}catch{location.href=nvCartBase+'cart'}
  }catch(error){message.textContent=error.message}
  if(button)button.disabled=false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuveya-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.nv-home-reviews').forEach(section=>{const cards=[...section.querySelectorAll('.nv-home-review')];const count=section.querySelector('[data-nv-review-count]');let current=0;function draw(){const visible=window.innerWidth<750?1:window.innerWidth<950?2:3;const pages=Math.max(1,cards.length-visible+1);current=Math.max(0,Math.min(current,pages-1));cards.forEach((card,i)=>{card.style.display=i>=current&&i<current+visible?'flex':'none'});count.textContent=(current+1)+' / '+pages;section.querySelector('[data-nv-review-prev]').disabled=current===0;section.querySelector('[data-nv-review-next]').disabled=current===pages-1}section.querySelector('[data-nv-review-prev]').addEventListener('click',()=>{current--;draw()});section.querySelector('[data-nv-review-next]').addEventListener('click',()=>{current++;draw()});window.addEventListener('resize',draw);draw()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuveya-ingredients"] && !Shopify.designMode) return;
  try {
    
function nvIngredientsInit(root){
  const track=root.querySelector('[data-nv-ingredients-track]');
  const controls=root.querySelector('[data-nv-ingredients-controls]');
  const cards=[...track.querySelectorAll('.nv-ingredients__card')];
  const previous=controls.querySelector('[data-nv-ingredients-prev]');
  const next=controls.querySelector('[data-nv-ingredients-next]');
  const count=controls.querySelector('[data-nv-ingredients-count]');
  let page=0;
  const visible=()=>window.matchMedia('(max-width:749px)').matches?1:3;
  const pages=()=>Math.max(1,cards.length-visible()+1);
  function render(){
    page=Math.min(page,pages()-1);
    count.textContent=`${page+1} / ${pages()}`;
    previous.disabled=page===0;
    next.disabled=page===pages()-1;
    controls.hidden=pages()===1;
  }
  function show(index){
    if(!cards.length)return;
    page=Math.max(0,Math.min(index,pages()-1));
    track.scrollTo({left:cards[page].offsetLeft-cards[0].offsetLeft,behavior:'smooth'});
    render();
  }
  previous.addEventListener('click',()=>show(page-1));
  next.addEventListener('click',()=>show(page+1));
  track.addEventListener('scroll',()=>{
    if(cards.length<2)return;
    const step=cards[1].offsetLeft-cards[0].offsetLeft;
    const position=Math.min(pages()-1,Math.max(0,Math.round(track.scrollLeft/step)));
    if(position!==page){page=position;render()}
  },{passive:true});
  window.addEventListener('resize',()=>show(page));
  render();
}
document.querySelectorAll('.nv-ingredients').forEach(nvIngredientsInit);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.nv-ingredients').forEach(nvIngredientsInit));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuveya-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.nv-product__gallery').forEach(gallery=>{const slides=[...gallery.querySelectorAll('[data-nv-slide]')];const dots=gallery.querySelector('[data-nv-dots]');let current=0;function show(index){if(!slides.length)return;current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===current));dots.querySelectorAll('button').forEach((dot,i)=>dot.classList.toggle('is-active',i===current));dots.querySelector('button.is-active')?.scrollIntoView({block:'nearest',inline:'nearest'})}slides.forEach((slide,i)=>{const dot=document.createElement('button');dot.type='button';dot.setAttribute('aria-label',String(i+1));const source=slide.querySelector('img');if(source){const thumbnail=document.createElement('img');thumbnail.src=source.currentSrc||source.src;thumbnail.alt='';thumbnail.loading='lazy';dot.append(thumbnail)}dot.addEventListener('click',()=>show(i));dots.append(dot)});gallery.querySelector('[data-nv-prev]')?.addEventListener('click',()=>show(current-1));gallery.querySelector('[data-nv-next]')?.addEventListener('click',()=>show(current+1));show(0)});
document.querySelectorAll('[data-nv-quotes]').forEach(carousel=>{const slides=[...carousel.querySelectorAll('[data-nv-quote]')];let current=0;function show(index){if(!slides.length)return;current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===current));carousel.querySelector('[data-nv-quote-prev]').disabled=current===0}carousel.querySelector('[data-nv-quote-prev]')?.addEventListener('click',()=>show(current-1));carousel.querySelector('[data-nv-quote-next]')?.addEventListener('click',()=>show(current+1));show(0)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuveya-proof"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.nv-proof').forEach(section=>{const cards=[...section.querySelectorAll('.nv-proof__card')];const prev=section.querySelector('[data-nv-proof-prev]');const next=section.querySelector('[data-nv-proof-next]');const count=section.querySelector('[data-nv-proof-count]');let index=0;function show(){const visible=window.matchMedia('(max-width:749px)').matches?1:3;const pages=Math.max(1,cards.length-visible+1);index=Math.max(0,Math.min(index,pages-1));cards.forEach((card,i)=>card.classList.toggle('is-active',i>=index&&i<index+visible));count.textContent=`${index+1} / ${pages}`;prev.disabled=index===0;next.disabled=index===pages-1}prev.addEventListener('click',()=>{index--;show()});next.addEventListener('click',()=>{index++;show()});window.addEventListener('resize',show);show()});

  } catch(e) { console.error(e); }
})();
})();
